const VARIABLE_NODE_TYPE = 'variable';

function isOldSlateFormat(possibleSlateValue) {
  if (typeof possibleSlateValue === 'string') {
    try {
      possibleSlateValue = JSON.parse(possibleSlateValue);
    } catch (error) {
      return false;
    }
  }

  return (
    typeof possibleSlateValue === 'object' &&
    possibleSlateValue !== null &&
    possibleSlateValue.object === 'value' &&
    possibleSlateValue.document &&
    possibleSlateValue.document.object === 'document'
  );
}

function convertNode(oldNode) {
  // Handle null/undefined nodes
  if (!oldNode) {
    return { text: '' };
  }

  const { object, type, data, nodes = [], text = '', marks = [] } = oldNode;

  // Handle variable nodes
  if (type === VARIABLE_NODE_TYPE) {
    return {
      type: VARIABLE_NODE_TYPE,
      data: data || {},
      children: [{ text: '' }],
    };
  }

  // Handle text nodes
  if (object === 'text') {
    const textNode = { text };

    // Add formatting properties based on marks
    if (marks && marks.length > 0) {
      marks.forEach(mark => {
        textNode[mark.type] = true;
      });
    }

    return textNode;
  }

  // Handle block nodes (like paragraphs)
  if (object === 'block') {
    // If this block contains variables and isn't already a paragraph, wrap it
    if (nodes.some(node => node.type === VARIABLE_NODE_TYPE) && type !== 'paragraph') {
      return {
        type: 'paragraph',
        children: nodes.map(node => convertNode(node)),
      };
    }

    return {
      type: type,
      data: data || {},
      children: nodes.map(node => convertNode(node)).filter(Boolean),
    };
  }

  // Fallback for unknown node types
  return { text: '' };
}

function convertOldSlateToNew(slateValue) {
  // Handle empty/invalid input
  if (!slateValue?.document?.nodes) {
    return [{ type: 'paragraph', children: [{ text: '' }] }];
  }

  // Convert and flatten the document's nodes
  const converted = slateValue.document.nodes
    .map(node => convertNode(node))
    .flat()
    .filter(Boolean);

  // Ensure we have at least one paragraph
  return converted.length > 0 ? converted : [{ type: 'paragraph', children: [{ text: '' }] }];
}

export function loadSlateContent(valueOrOldSlate) {
  // Handle null/undefined
  if (!valueOrOldSlate) {
    return [{ type: 'paragraph', children: [{ text: '' }] }];
  }

  // If it's already an array in the new format
  if (Array.isArray(valueOrOldSlate)) {
    return valueOrOldSlate;
  }

  // If it's old data, convert it
  if (isOldSlateFormat(valueOrOldSlate)) {
    return convertOldSlateToNew(valueOrOldSlate);
  }

  // If it's a string or other format, wrap it in a paragraph
  return [
    {
      type: 'paragraph',
      children: [{ text: String(valueOrOldSlate) }],
    },
  ];
}
